import React from 'react';
import { observer } from 'mobx-react';
import { lookupsJson } from '@ourbranch/lookups';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const InlandFloodCoverageForm = ({ fieldName, disabled }) => {
  const classes = useStyles();

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Inland flood coverage</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={4}
          type="date"
          id={`${fieldName}.inlandFloodInceptionDate`}
          name={`${fieldName}.inlandFloodInceptionDate`}
          mode="dark"
          label="Inception date"
          disabled={disabled}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.inlandFloodOccurrenceLimit`}
          name={`${fieldName}.inlandFloodOccurrenceLimit`}
          mode="dark"
          label="Per occurrence limit"
          disabled={disabled}
          options={lookupsJson.farm.inlandFloodLimit}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.inlandFloodDeductible`}
          name={`${fieldName}.inlandFloodDeductible`}
          mode="dark"
          label="Deductible"
          options={lookupsJson.farm.inlandFloodDeductible}
          disabled={disabled}
        />
        <Field
          xs={6}
          type="value"
          id={`${fieldName}.inlandFloodAggregateLimit`}
          name={`${fieldName}.inlandFloodAggregateLimit`}
          mode="dark"
          label="Inland flood aggregate limit"
          disabled={disabled}
        />
        <Field
          xs={6}
          type="value"
          id={`${fieldName}.inlandFloodRiskScore`}
          name={`${fieldName}.inlandFloodRiskScore`}
          mode="dark"
          label="Inland flood risk score"
          disabled={disabled}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

InlandFloodCoverageForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

InlandFloodCoverageForm.defaultProps = {
  disabled: false
};

export default observer(InlandFloodCoverageForm);
